import { Dispatch, MouseEvent, SetStateAction, useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./ImageModal.module.css";
import Icon from "../../common/Icon";
import { ImageOptions } from "./GridGallery";

interface ImageModalProps {
    showModal: boolean;
    setShowModal: Dispatch<SetStateAction<boolean>>;
    images: ImageOptions[];
    selected: number;
    setSelected: Dispatch<SetStateAction<number>>
}

/**
 * 장소 이미지 확대 보기
 * @author mjkang
 * @param props {@link ImageModalProps}
 * @returns ImageModal
 */
const ImageModal = (props: ImageModalProps) => {
    const hasPrev = props.selected > 0;
    const hasNext = props.selected < props.images.length - 1;

    const prevButtonOption = {
        name: "arrowBack",
        color: hasPrev ? "white" : "darkGrey",
    };

    const nextButtonOption = {
        name: "arrowForward",
        color: hasNext ? "white" : "darkGrey",
    };

    useEffect(() => {
        if(props.images.length < props.selected || props.selected === -1) {
            props.setShowModal(false);
        }
    }, [props.selected]);

    const closeModal = (e: MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        props.setShowModal(false);
    }

    const prevImage = () => {
        const current = props.selected;
        if(current > 0) {
            props.setSelected(current - 1);
        }
    }

    const nextImage = () => {
        const current = props.selected;
        if (current < props.images.length - 1) {
            props.setSelected(current + 1);
        }
    }

    return (
        <>
            {props.showModal &&
                createPortal(
                    <div className={`${styles.wrapper} undraggable`}>
                        <div className={styles.close} onClick={closeModal}>
                            <Icon name="close" color="white" size="large" />
                        </div>
                        <div className={styles.image}>
                            <img src={props.images[props.selected].url} />
                        </div>
                        <div className={styles.buttons}>
                            <div className={styles.button} onClick={hasPrev ? prevImage : undefined}>
                                <Icon {...prevButtonOption} />
                            </div>
                            <div className={styles.button} onClick={hasNext ? nextImage : undefined}>
                                <Icon {...nextButtonOption} />
                            </div>
                        </div>
                    </div>,
                    document.body
                )}
        </>
    );
}
 
export default ImageModal;